import SuperFetch from '../../../superFetch.js';

class NoticeApi {
  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 가져오기
   */
  getNoticeProductList = (data) => SuperFetch.post('/notice/product/list', data);

  /**
   *  [상품 공지사항 리스트] 상품 공지사항 리스트 엑셀 다운로드 하기
   */
  getNoticeProductExcelDownload = (data) => SuperFetch.post('/notice/product/list/excel/download', data);

  /**
   *  [상품 공지사항 리스트] 공지사항 삭제 요청하기
   */
  deleteNoticeProduct = (data) => SuperFetch.post('/notice/product/list/delete', data);

  /**
   *  [상품 공지사항 편집] 상품 공지사항 요청하기
   */
  getNoticeProductInfo = (data) => SuperFetch.post('/notice/product/detail', data);

  /**
   *  [상품 공지사항 편집] 상품 공지사항에 등록된 상품 목록 구하기
   */
  getNoticeProductItemInfo = (data) => SuperFetch.post('/app/notice/product/item/list', data);
}

export default new NoticeApi();
